(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mb-market-picker"] && !Shopify.designMode) return;
  try {
    (() => {
  const refresh = () => {
    document.querySelectorAll('[data-mb-market-picker]').forEach((picker, index) => {
      const panel = picker.querySelector('.mb-market-panel');
      const summary = picker.querySelector('summary');
      if (!panel || !summary) return;
      const base = picker.dataset.mbPickerBase || panel.id;
      picker.dataset.mbPickerBase = base;
      panel.id = base + '-instance-' + index;
      summary.setAttribute('aria-controls', panel.id);
    });
    document.querySelectorAll('a[data-mb-market-option]').forEach(link => {
    const target = new URL(link.dataset.mbMarketUrl, location.origin);
    if (target.origin !== location.origin) return;
    target.search = location.search;
    target.searchParams.set('country', link.dataset.mbCountry);
    link.href = target.href;
    });
  };
  refresh();
  document.addEventListener('DOMContentLoaded', refresh);
  document.addEventListener('shopify:section:load', refresh);
  let consumedEscape = false;
  let consumedSpace = false;
  document.addEventListener('keydown', event => {
    if (event.key === ' ' || event.code === 'Space') {
      const summary = event.target.closest('[data-mb-market-picker] > summary');
      if (summary) {
        consumedSpace = true;
        if (!event.repeat) summary.parentElement.open = !summary.parentElement.open;
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
    }
    if (event.key !== 'Escape') return;
    const picker = event.target.closest('[data-mb-market-picker][open]');
    if (!picker) return;
    consumedEscape = true;
    picker.open = false;
    picker.querySelector('summary').focus();
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);
  document.addEventListener('keyup', event => {
    if ((event.key === ' ' || event.code === 'Space') && consumedSpace) {
      consumedSpace = false;
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    if (event.key !== 'Escape' || !consumedEscape) return;
    consumedEscape = false;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);
  document.addEventListener('click', event => document.querySelectorAll('[data-mb-market-picker][open]').forEach(picker => {
    if (!picker.contains(event.target)) picker.open = false;
  }));
})();
  } catch(e) { console.error(e); }
})();

})();
